export const LOGIN_SUPPORT_URL_CRASHPLAN = 'https://www.crashplan.com/r/support/con-2fa-auth-code-prompt-cp';
export const LOGIN_SUPPORT_URL_SMB = 'https://www.crashplan.com/r/support/con-2fa-auth-code-prompt-smb';

export const PAGE_URL_SMB = `https://${window.__SMB_URL}/login`;
export const PAGE_URL_CPG = `https://${window.__CPG_URL}/login`;
